import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export const CheckMarkCircle = ({ ...rest }) => {
  return <IoMdCheckmarkCircleOutline {...rest} />;
};
